<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper" style="min-height: 307px">
  <section id="maingroupcut">
    <div class="col-md-12">
      <div class="row">
        <div class="card">
          <div class="card-header bg-success">
            รายการข้อมูล บันทึกกลุ่มตัดกลุ่มบำรุง
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <div class="input-group mb-3" [formGroup]="FormCutGroup">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="หมายเลขแปลง โควตาชาวไร่"
                    formControlName="fmdata"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  />
                  <button
                    mat-raised-button
                    color="warn"
                    (click)="LoadDatabyFmcode()"
                  >
                    ค้นหา
                  </button>
                </div>
              </div>
            </div>

        

            <div class="card">
              <div class="card-header d-flex p-0">
                <h3 class="card-title p-3">รายการ</h3>
                <ul class="nav nav-pills ml-auto p-2">
                  <li class="nav-item">
                    <a class="nav-link " href="#tab_1" data-toggle="tab"
                      >กลุ่มตัด</a
                    >
                  </li>
                  <li class="nav-item">
                    <a class="nav-link active" href="#tab_2" data-toggle="tab"
                      >กลุ่มบำรุง</a
                    >
                  </li>
                  <!-- <li class="nav-item">
                    <a class="nav-link" href="#tab_3" data-toggle="tab"
                      >Tab 3</a
                    >
                  </li> -->
                  
                </ul>
              </div>
              <div class="card-body">
                <div class="tab-content">
                  <div class="tab-pane " id="tab_1">
                    <div class="row">
                        <div class="col-md-12">
                          <table class="table">
                            <thead>
                              <tr>
                                <th scope="col">โซน</th>
                                <th scope="col">รูท</th>
                                <th scope="col">หมายเลขแปลง</th>
                                <th scope="col">ชื่อ - สกุล</th>
                                <th scope="col">ประเภทอ้อย</th>
                                <th scope="col">พื้นที่</th>
                                <th scope="col">ประเมิน</th>
                                <th scope="col">ตันต่อไร่</th>
                                <th scope="col">งวดตัด</th>
                                <th scope="col">กลุ่มตัด</th>
                                <th scope="col">ประเภทคิว</th>
                                <th scope="col">ยืนยันพื้นที่</th>
                                <th scope="col">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let item of fmlist">
                                <td>{{item.supzone}}</td>
                                <td>{{item.route}}</td>
                                <td>{{item.intlandno}}</td>
                                <td>{{item.fmname}}</td>
                                <td>{{item.CaneTypeName}}</td>
                                <td>{{item.landvalue | number}}</td>
                                <td>{{item.Assess | number}}</td>
                                <td>{{item.Ton | number}}</td>
                                <td>{{item.period_cut}}</td>
                                <td>{{item.groupCode}}</td>
                                <td>{{item.qdesc}}</td>
                                <td>{{item.confirm_area_doc}}</td>
                                <td>
                                  <div class="btn-group">
                                    <button type="button" class="btn btn-danger dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-expanded="false">
                                      <span class="visually-hidden">Toggle Dropdown</span>
                                    </button>
                                    <ul class="dropdown-menu">
                                      <li><a class="dropdown-item" href="#">Action</a></li>
                                      <li><a class="dropdown-item" href="#">Another action</a></li>
                                      <li><a class="dropdown-item" href="#">Something else here</a></li>
                                      <li><hr class="dropdown-divider"></li>
                                      <li><a class="dropdown-item" href="#">Separated link</a></li>
                                    </ul>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                  </div>

                  <div class="tab-pane active" id="tab_2">
                    <div class="row">
                        <div class="col-md-12">
                          <table class="table">
                            <thead>
                              <tr>
                                <th scope="col">โซน</th>
                                <th scope="col">รูท</th>
                                <th scope="col">หมายเลขแปลง</th>
                                <th scope="col">ชื่อ - สกุล</th>
                                <th scope="col">ประเภทอ้อย</th>
                                <th scope="col">พื้นที่</th>
                                <th scope="col">ประเมิน</th>
                                <th scope="col">ตันต่อไร่</th>
                                <th scope="col">งวดตัด</th>
                                <th scope="col">กลุ่มบำรุง</th>
                                <th scope="col">ประเภทคิว</th>
                                <th scope="col">ยืนยันพื้นที่</th>
                                <th scope="col">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of fmlist">
                                    <td>{{item.supzone}}</td>
                                    <td>{{item.route}}</td>
                                    <td>{{item.intlandno}}</td>
                                    <td>{{item.fmname}}</td>
                                    <td>{{item.CaneTypeName}}</td>
                                    <td>{{item.landvalue | number}}</td>
                                    <td>{{item.Assess | number}}</td>
                                    <td>{{item.Ton | number}}</td>
                                    <td>{{item.period_cut}}</td>
                                    <td>{{item.groupCode_m}}</td>
                                    <td>{{item.qdesc}}</td>
                                    <td>{{item.confirm_area_doc}}</td>
                                    <td></td>
                                  </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                  </div>

                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="editcut"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">แก้ไขข้อมูล</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body" [formGroup]="FormCutGroup"></div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
              (click)="(false)"
            >
              บันทึกรายการ
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- MOdal -->

    <!-- Modal  checkcut-->
    <div
      class="modal fade"
      id="checkcut"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header bg-success">
            <h2 class="modal-title" id="exampleModalLabel">ยืนยันพื้นที่</h2>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body" [formGroup]="FormCutGroup">
            <select
              class="form-control"
              formControlName="selectconfirm"
            ></select>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
              (click)="(false)"
            >
              บันทึกรายการ
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- MOdal -->
  </section>
</div>
<app-footer></app-footer>
